export const calculateTimeLeft = (countdown: number) => {
  const now = Math.floor(Date.now() / 1000)
  const difference = countdown - now

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 }
  }

  const days = Math.floor(difference / (60 * 60 * 24))
  const hours = Math.floor((difference % (60 * 60 * 24)) / (60 * 60))
  const minutes = Math.floor((difference % (60 * 60)) / 60)
  const seconds = difference % 60

  return { days, hours, minutes, seconds }
}
